import { render } from "./table-evaluasi-stula.vue?vue&type=template&id=dd3e5066"
import script from "./table-evaluasi-stula.vue?vue&type=script&lang=js"
export * from "./table-evaluasi-stula.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__